'use client';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { getScreenerMeta } from '@/lib/api/screenerApi';
import type { ScreenerColumn, ScreenerMeta } from '@/types/screener';

export function useScreenerMeta() {
  const [meta, setMeta] = useState<ScreenerMeta | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    getScreenerMeta()
      .then((result) => {
        if (!cancelled) setMeta(result);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      });
    return () => {
      cancelled = true;
    };
  }, [attempt]);

  const columnsByKey = useMemo(() => {
    const byKey = new Map<string, ScreenerColumn>();
    meta?.columns.forEach((column) => byKey.set(column.key, column));
    return byKey;
  }, [meta]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  return { meta, error, columnsByKey, retry };
}
